import { render } from "./kubevirt.io.virtualmachine.vue?vue&type=template&id=02229b7e&scoped=true"
import script from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js"
export * from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js"

import "./kubevirt.io.virtualmachine.vue?vue&type=style&index=0&id=02229b7e&lang=scss"
import "./kubevirt.io.virtualmachine.vue?vue&type=style&index=1&id=02229b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02229b7e"]])

export default __exports__